export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkExpertise: "nav-link-expertise",
  linkEntreprises: "nav-link-entreprises",
  linkParticuliers: "nav-link-particuliers",
  linkApproche: "nav-link-approche",
  linkActualites: "nav-link-actualites",
  linkContact: "nav-link-contact",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  root: "hero-root",
  headline: "hero-headline",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const EXPERTISE = {
  root: "expertise-root",
  cardVie: "expertise-card-vie",
  cardIrd: "expertise-card-ird",
  cardPer: "expertise-card-per",
  cardPrev: "expertise-card-prevoyance",
};

export const CIBLES = {
  root: "cibles-root",
  cardEntreprises: "cibles-card-entreprises",
  cardParticuliers: "cibles-card-particuliers",
};

export const APPROCHE = {
  root: "approche-root",
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputPhone: "contact-input-phone",
  inputCompany: "contact-input-company",
  selectProfile: "contact-select-profile",
  selectInterest: "contact-select-interest",
  inputMessage: "contact-input-message",
  submit: "contact-submit-button",
  successToast: "contact-success-toast",
};

export const FOOTER = {
  root: "footer-root",
};

export const NEWS = {
  root: "news-root",
  filterAll: "news-filter-all",
  filterActualite: "news-filter-actualite",
  filterPromotion: "news-filter-promotion",
  filterAvantage: "news-filter-avantage",
  card: (slug) => `news-card-${slug}`,
  detailRoot: "news-detail-root",
  detailBack: "news-detail-back",
};
